
        <kendo-grid-filter-menu-input-wrapper
            [column]="column"
            [filter]="filter"
            [operators]="operators"
            [defaultOperator]="operator"
            [currentFilter]="currentFilter"
            [filterService]="filterService"
            [isFirstDropDown]="isFirstDropDown"
            [menuTabbingService]="menuTabbingService"
            >
            <input
                class="k-textbox"
                kendoFilterInput
                [columnLabel]="columnLabel"
                [filterDelay]="0"
                [ngModel]="currentFilter?.value" />
        </kendo-grid-filter-menu-input-wrapper>
    